// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getStorage, ref } from "firebase/storage";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


// const firebaseConfig = {
//     apiKey: "AIzaSyBW97ZrzLnnmf4nhzNBBX0D6AYUxuIsOrc",
//     authDomain: "minganicdesigns-a4856.firebaseapp.com",
//     projectId: "minganicdesigns-a4856",
//     storageBucket: "minganicdesigns-a4856.appspot.com",
//     messagingSenderId: "265606160429",
//     appId: "1:265606160429:web:7d1aaa04baee0df44ad8a4",
//     measurementId: "G-GGBNVWKRPZ"
// };


const API_KEY = process.env.REACT_APP_FIREBASE_API_KEY
const AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID
const STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
const MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
const APP_ID = process.env.REACT_APP_FIREBASE_APP_ID
const MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID


const firebaseConfig = {
    apiKey: API_KEY,
    authDomain: AUTH_DOMAIN,
    projectId: PROJECT_ID,
    storageBucket: STORAGE_BUCKET,
    messagingSenderId: MESSAGING_SENDER_ID,
    appId: APP_ID,
    measurementId: MEASUREMENT_ID
};


// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);

const firebaseStorage = getStorage(firebaseApp);
const firebaseStorageRef = ref(firebaseStorage);

const firebaseAuth = getAuth(firebaseApp);

// Custom Hook
export function useAuth() {
    const [currentUser, setCurrentUser] = useState();

    useEffect(() => {
        const unsub = onAuthStateChanged(firebaseAuth, user => setCurrentUser(user));
        return unsub;
    }, [])

    return currentUser;
}

export {
    firebaseApp, firebaseStorage, firebaseStorageRef, firebaseAuth
}